import {Injectable} from '@angular/core';
import * as $ from 'jquery';

declare let document: any;

interface Script {
    src: string;
    loaded: boolean;
}

@Injectable()
export class ScriptLoaderService {
    private _scripts: Script[] = [];
    private tag: any;

    load(tag, ...scripts: string[]) {
        this.tag = tag;
        scripts.forEach((script: string) => {
            if (!this._scripts[script]) {
                this._scripts[script] = {src: script, loaded: false};
            } else {
                if (!this._scripts[script].loaded) {
                    this._scripts[script] = {src: script, loaded: false};
                }
            }
        });
        const promises: any[] = [];
        scripts.forEach((script) => promises.push(this.loadScript(script)));
        return Promise.all(promises);
    }

    loadScript(src: string) {
        return new Promise((resolve, reject) => {
            // resolve if already loaded
            if (this._scripts[src].loaded) {
                resolve({script: src, loaded: true, status: 'Already Loaded'});
            } else {
                const is_loaded = document.querySelector('script[src="' + src + '"]');
                if (is_loaded) {
                    is_loaded.remove();
                    if (window['google']) {
                        // Remove google from BOM (window object)
                        window['google'] = undefined;
                    }
                }
                // load script
                const script = $('<script/>')
                    .attr('type', 'text/javascript')
                    .attr('src', this._scripts[src].src);
                this._scripts[src].loaded = true;
                $(this.tag).append(script);
                resolve({script: src, loaded: true, status: 'Loaded'});
            }
        });
    }
}